<span mat-dialog-title>{{'dialog.error.title' | translate}}</span>
<mat-dialog-content class="mat-typography">
  <div>{{'dialog.error.summary' | translate}}</div>
  <div><h4>{{'dialog.error.type' | translate}}</h4></div>
  <div>{{errorActionType}}</div>
  <div><h4>{{'dialog.error.name' | translate}}</h4></div>
  <div>{{error.name}}</div>
  <div><h4>{{'dialog.error.message' | translate}}</h4></div>
  <div>{{message}}</div>
  @if (showDebug) {
    @if (!!error.stack) {
      <div><h4>{{'dialog.error.stack' | translate}}</h4></div>
      <div class="pm-frame">
        <pre>{{error.stack}}</pre>
      </div>
    }
    <div><h4>{{'dialog.error.action' | translate}}</h4></div>
    <div class="pm-frame">
      <pre>{{action | json}}</pre>
    </div>
    @if ((hasSaveHistory$ | async)) {
      <h4>{{'dialog.error.save-history' | translate}}</h4>
      <div class="pm-frame">
        @for (action of (prettySaveHistory$ | async); track action) {
          <pre>{{action}}</pre>
        }
      </div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>{{'button.close' | translate}}</button>
  <button (click)="sendError()" mat-raised-button [disabled]="reported || reporting">
    <span class="pm-inliner">@if (reporting) {
      <mat-spinner
      diameter="16"></mat-spinner>
    }
    @if (!reported) {
      {{'dialog.error.report' | translate}}
    }
    @if (reported) {
      {{'dialog.error.reported' | translate}}
    }
  </span>
</button>
</mat-dialog-actions>
